/** Snapshot of a selected account character, retained with the chapter and its takes. */
export type StudioCharacter = {
  id: string;
  name: string;
  description: string;
  avatarUrl?: string;
  voiceId?: string;
};

export const MAX_BLUEPRINT_CHARACTERS = 8;
export const describeCharacters = (characters: StudioCharacter[]) =>
  characters.map((c) => `${c.name} — ${c.description}`).join("\n");

export const blueprintStartingPoint =
  "Start with an idea of your own, ask for a blueprint suggestion, or add characters to build your story around.";

export const blueprintSuggestion =
  "Create a blueprint for a gentle adventure about a hidden garden that only blooms when someone helps a stranger. Start with a mysterious invitation, add a small act of courage, and end with a warm surprise. Aim for a three-minute story for families.";
